import { Product } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 0410. 売上カテゴリ登録
 * [POST] /workspaces/:identifier/products
 */
type Props = {
  identifier: string;
  id: number;
  name: string;
  description?: string;
  spot_available: boolean;
  spot_amount?: number;
  monthly_available: boolean;
  monthly_amount?: number;
  contract_term_available: boolean;
  delivery_date_available: boolean;
  invalidity: boolean;
};
const updateProduct = (props: Props): Promise<Product> => {
  return axios.put(`/api/workspaces/${props.identifier}/products/${props.id}`, props);
};

export const useUpdateProduct = () => {
  return useMutation({
    mutationFn: updateProduct,
  });
};
